import styled from "@emotion/styled"
import { css, keyframes } from '@emotion/react'
import facepaint from "facepaint"

import Button from 'components/forms/button/Button'

const breakpoints = [440, 768, 1024, 1200, 1400]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-16px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const wrapMQ = css(mq({
  maxWidth: [
    "calc(100vw - 40px)", // 0+
    "calc(100vw - 40px)", // 440+
    "calc(100vw - 72px)", // 768+
    "calc(100vw - 72px)", // 1024+
    "calc(100vw - 72px)", // 1200+
    "calc(100vw - 72px)", // 1400+
  ],
  gap: [
    24,
    24,
    32,
  ],
  margin: [
    "32px auto 64px", // 0+
    "32px auto 64px", // 440+
    "48px auto", // 768+
    "72px auto", // 1024+
  ],
}))

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 1038px;
  align-items: center;
  ${wrapMQ}
`

const titleMQ = css(mq({
  font: [
    "var(--accent-870)", // 0+
    "var(--accent-870)", // 440+
    "var(--accent-970)", // 768+
    "var(--accent-1170)", // 1024+
    "var(--accent-1170)", // 1200+
    "var(--accent-1170)", // 1400+
  ],
  textAlign: [
    "left",
    "left",
    "center",
  ],
}))

export const Title = styled.h1`
  color: var(--color-grayscale-900);
  background: linear-gradient(180deg, #2B2E31 39.88%, #484D51 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation-delay: .1s;
  animation-duration: .75s;
  animation-fill-mode: both;
  animation-name: ${slideDown};
  animation-timing-function: ease;
  ${titleMQ}

  & > ins {
    color: #F96674;
    text-decoration: none;
    background: linear-gradient(266deg, var(--color-branding) 7.5%, #F96674 37.58%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`

const descriptionMQ = css(mq({
  font: [
    "var(--text-540)", // 0+
    "var(--text-540)", // 440+
    "var(--text-640)", // 768+
    "var(--text-640)", // 1024+
    "var(--text-640)", // 1200+
    "var(--text-640)", // 1400+
  ],
  textAlign: [
    "left",
    "left",
    "center",
  ],
}))

export const Description = styled.h2`
  max-width: 760px;
  color: var(--color-grayscale-900);
  animation-duration: .75s;
  animation-fill-mode: both;
  animation-name: ${slideDown};
  animation-timing-function: ease;
  animation-delay: .3s;
  ${descriptionMQ}
`

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 16px;
  animation-duration: .75s;
  animation-fill-mode: both;
  animation-name: ${slideDown};
  animation-timing-function: ease;
  animation-delay: .6s;
`

const bookButtonMQ = css(mq({
  width: [
    "100%",
    "100%",
    "auto",
  ],
  font: [
    "var(--text-550)",
    "var(--text-550)",
    "var(--text-650)",
  ],
  borderRadius: [
    10,
    10,
    14,
  ],
  height: [
    48,
    48,
    56,
  ],
}))

export const BookButton = styled(Button)`
  ${bookButtonMQ}
`
